import {INIT_APP} from '~/common/fabric/constants';
import {PROPAGATE_STEP_CHANGE} from '../constants';
import {
  RECIPIENT_CARD_SELECTED,
  RECIPIENT_EXITING_PAGE,
  RECIPIENT_FILTER,
  REMOVE_INDIVIDUAL_MESSAGE,
  UPDATE_GLOBAL_MESSAGE,
  UPDATE_INDIVIDUAL_MESSAGE,
} from './contants';

const initialState = {
  recipientMessages: {},
  globalMessage: '',
  recipientSelected: null,
  recipientFilter: '',
  persistAllMessages: false,
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_GLOBAL_MESSAGE:
      return {...state, globalMessage: action.payload};
    case UPDATE_INDIVIDUAL_MESSAGE:
      return {
        ...state,
        recipientMessages: {...state.recipientMessages, ...action.payload},
      };
    case REMOVE_INDIVIDUAL_MESSAGE: {
      const {recipientMessages} = state;
      delete recipientMessages[action.payload];
      return {
        ...state,
        recipientMessages: {...recipientMessages},
        recipientSelected: null,
      };
    }
    case RECIPIENT_CARD_SELECTED:
      return {...state, recipientSelected: action.payload};
    case RECIPIENT_FILTER:
      return {...state, recipientFilter: action.payload};
    case PROPAGATE_STEP_CHANGE:
      return {...state, persistAllMessages: false, recipientFilter: ''};
    case RECIPIENT_EXITING_PAGE:
      return {...state, persistAllMessages: true, recipientSelected: null};
    case INIT_APP:
      return {
        ...state,
        globalMessage: action.payload.event?.options?.write?.text_layer_back || '',
      };
    default:
      return state;
  }
};
